module.exports = __webpack_public_path__ + "img/mobile-single-apple.b5ab137a.svg";